import * as ko from "knockout";
import entityBase from "entityBase";
import { person_place } from "./person_place";
import { person_role } from "./person_role";

export class person extends entityBase {
  email_address: KnockoutObservable<string>;
  first_name: KnockoutObservable<string>;
  last_name: KnockoutObservable<string>;
  full_name: KnockoutObservable<string>;
  person_id: KnockoutObservable<string>;
  phone: KnockoutObservable<string>;
  person_place: KnockoutObservableArray<person_place>;
  person_role: KnockoutObservableArray<person_role>;

  constructor(item?: any) {
    super();
    this.email_address = ko.observable(item?.email_address).extend({ maxLength: 128 }).extend({ required: true });
    this.first_name = ko.observable(item?.first_name).extend({ maxLength: 64 });
    this.last_name = ko.observable(item?.last_name).extend({ maxLength: 128 });
    this.full_name = ko.observable(item?.full_name);
    this.person_id = ko.observable(item?.person_id).extend({ maxLength: 50 });
    this.phone = ko.observable(item?.phone).extend({ maxLength: 32 }).extend({ required: true });
    this.person_place = ko.observableArray();
    this.person_role = ko.observableArray();
    if (item?.person_place) {
      this.person_place = <KnockoutObservableArray<person_place>>(
        this.loadRelation(item, person_place, "person_place", "array")
      );
    }
    if (item?.person_role) {
      this.person_role = <KnockoutObservableArray<person_role>>(
        this.loadRelation(item, person_role, "person_role", "array")
      );
    }
  }
}
